import Cookies from "js-cookie";
import Config from "@/config";
import {getRootDomain} from "@/utils/index";

const TokenKey = Config.TOKEN_KEY
const PrincipalKey = Config.PRINCIPAL_KEY

const UserUtil = {}

/**
 * 获取凭证
 * @returns {any|null}
 */
UserUtil.getPrincipal = function () {
    const principal = Cookies.get(PrincipalKey)
    if (principal) {
        return JSON.parse(principal)
    }
    return null
}

/**
 * 获取用户ID
 * @returns {null|*|null}
 */
UserUtil.getUserId = function () {
    const principal = UserUtil.getPrincipal()
    if (principal) {
        return principal.userId
    }
    return null
}

/**
 * 退出
 * @returns {*}
 */
UserUtil.logout = function () {
    const domain = getRootDomain()
    Cookies.remove(PrincipalKey, {domain})
    return Cookies.remove(TokenKey, {domain})
}

export default UserUtil
